import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const CarTransmissionIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: "19",
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M16.5869 0.9375C15.0755 0.9375 13.8458 2.06466 13.8458 3.45013C13.8458 4.66352 14.7891 5.67873 16.0387 5.9122V8.50888C16.0387 8.78597 15.7928 9.01141 15.4905 9.01141H10.52V5.9122C11.7697 5.67876 12.7129 4.66356 12.7129 3.45013C12.7129 2.06466 11.4832 0.9375 9.97183 0.9375C8.46042 0.9375 7.23078 2.06466 7.23078 3.45013C7.23078 4.66352 8.174 5.67873 9.42362 5.9122V9.01141H3.90498V5.9122C5.1546 5.67876 6.09782 4.66356 6.09782 3.45013C6.09782 2.06466 4.86818 0.9375 3.35677 0.9375C1.84536 0.9375 0.615723 2.06466 0.615723 3.45013C0.615723 4.66352 1.55894 5.67873 2.80856 5.9122V13.1157C1.55894 13.3491 0.615723 14.3643 0.615723 15.5777C0.615723 16.9632 1.84536 18.0904 3.35677 18.0904C4.86818 18.0904 6.09782 16.9632 6.09782 15.5777C6.09782 14.3643 5.1546 13.3491 3.90498 13.1157V10.0165H9.42362V13.1157C8.174 13.3491 7.23078 14.3643 7.23078 15.5777C7.23078 16.9632 8.46042 18.0904 9.97183 18.0904C11.4832 18.0904 12.7129 16.9632 12.7129 15.5777C12.7129 14.3643 11.7697 13.3491 10.52 13.1157V10.0165H15.4905C16.3973 10.0165 17.1351 9.34016 17.1351 8.50888V5.9122C18.3847 5.67876 19.3279 4.66356 19.3279 3.45013C19.3279 2.06466 18.0983 0.9375 16.5869 0.9375Z",
    fill: color
  }));
};
export default CarTransmissionIcon;